import { Component, OnInit } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { OrderService } from '../../../services/order/order.service';

@Component({
  selector: 'app-ordermapview',
  templateUrl: './ordermapview.component.html',
  styleUrls: ['./ordermapview.component.scss']
})
export class OrdermapviewComponent implements OnInit {
  unplannedCount: number = 0;
  inPlanningCount: number = 0;
  scheduledCount: number = 0;
  intransitCount: number = 0;
  failedCount: number = 0;
  deliveredCount: number = 0;
  zoom: number = 11;
  lat: number = 18.533989;
  lng: number = 73.825592;
  OrderMapMarker: any;
  markers: any;
  page: number = 0;
  markersArr = [];
  constructor(
    public orderService: OrderService
  ) { }

  ngOnInit() {

    // this.OrderMapMarker = new OrderMapDataSource(this.orderService, 'unplanned');
    // console.log(this.OrderMapMarker.destinationAddress);
    // this.markers = this.OrderMapMarker.destinationAddress;
    // console.log(this.markers);
    let type = 'ORDER_STATE_UNPLANNED';

    this.generateMapData(type);

/*     this.orderService.getOrderCountByStatus().subscribe(res => {
      console.log(res);
      if (this.searchArraryForCount(res, 'ORDER_STATE_UNPLANNED') != undefined) {
        this.unplannedCount = this.searchArraryForCount(res, 'ORDER_STATE_UNPLANNED').ordercount;
      }
      if (this.searchArraryForCount(res, 'ORDER_STATE_IN_PLANNING') != undefined) {
        this.inPlanningCount = this.searchArraryForCount(res, 'ORDER_STATE_IN_PLANNING').ordercount;
      }

      if (this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED') != undefined) {
        this.scheduledCount = this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED').ordercount;
      }

      if (this.searchArraryForCount(res, 'ORDER_STATE_IN_TRANSIT') != undefined) {
        this.intransitCount = this.searchArraryForCount(res, 'ORDER_STATE_IN_TRANSIT').ordercount;
      }

      if (this.searchArraryForCount(res, 'ORDER_STATE_FAILED') != undefined) {
        this.failedCount = this.searchArraryForCount(res, 'ORDER_STATE_FAILED').ordercount;
      }

      if (this.searchArraryForCount(res, 'ORDER_STATE_DELIVERED') != undefined) {
        this.deliveredCount = this.searchArraryForCount(res, 'ORDER_STATE_DELIVERED').ordercount;
      }
      // for(let i = 0; i < res.length; i++){
      //   this.inPlanningCount = res[i].
      // }
    });
 */  }

  searchArraryForCount(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].orderstatus === value) {
        return arr[i];
      }
    }
  }

  orderData(type) {

    console.log(type);
    switch (type) {

      case "unplanned":

        this.generateMapData('ORDER_STATE_UNPLANNED');
        break;
      case "inplanning":
        this.generateMapData('ORDER_STATE_IN_PLANNING');
        break;
      case "scheduled":

        this.generateMapData('ORDER_STATE_SCHEDULED');
        break;
      case "intransit":

        this.generateMapData('ORDER_STATE_IN_TRANSIT');
        break;
      case "failed":

        this.generateMapData('ORDER_STATE_FAILED');
        break;
      case "delivered":
      default:

        this.generateMapData('ORDER_STATE_UNPLANNED');
    }
  }
  getData(type) {
    return this.orderService.getAllOrdersByTypes(type, this.page);
  }

  generateMapData(type) {
    this.markersArr = [];
    setTimeout(() => {
      this.orderService.getAllOrdersByTypes(type, this.page).subscribe(res => {
        //console.log(res);
        console.log("orders",res);
        for (let i = 0; i < res.length; i++) {
          // Iterate over numeric indexes from 0 to 5, as everyone expects.
          let newobj
          if (res[i].orderInfo.destinationAddress)
            newobj = res[i].orderInfo.destinationAddress.location;

          let labeldetails = res[i];
          //let newreceiverName = res[i].receiverName;
          if (newobj != null) {
            let lat, lng, orderID, receiverName = {};

            lat = newobj.coordinates[0];
            lng = newobj.coordinates[1];

            this.markersArr.push({
              lat: lat,
              lng: lng,
              orderId: labeldetails.orderInfo.orderInvoiceNumber,
              receiverName: labeldetails.orderInfo.receiverName
            })
          } else {

          }
        }
      })
    }, 500);

  }


  MapVIewSingle() {
    alert("mapiew");
  }

  // getLocation(type) {
  //   this.orderService.getAllOrders(type).subscribe(res => {
  //     console.log(res);
  //   })
  // }

}

// export interface markerObj {
//   lat?: number;
//   lng?: number;
//   orderId?: string;
//   receiverName?: string;
// }

// export interface OrderMapMarker {
//   houseNumber: string;
//   street: string;
//   landmark: string;
//   city: string;
//   pincode: number;
//   state: string;
//   country: string;
//   location:any;
//   lat: number;
//   lng: number;
//   label?: string;
// }

// export class OrderMapDataSource extends DataSource<any>{
//   constructor(private orderService: OrderService, private type: String) {
//     super();
//   }

//   connect(): Observable<OrderMapMarker[]> {
//     return this.orderService.getAllOrders(this.type);
//   }

//   disconnect() { }
// }